//  @jsx h

import { bem } from '@nrk/dh-utils';
import { h } from 'preact';
var style = {
  'togglePlayButton': 'dhfc-1_0_0-beta_26-togglePlayButton',
  'togglePlayButton__pauseIcon': 'dhfc-1_0_0-beta_26-togglePlayButton__pauseIcon',
  'togglePlayButton--playing': 'dhfc-1_0_0-beta_26-togglePlayButton--playing',
  'togglePlayButton__playIcon': 'dhfc-1_0_0-beta_26-togglePlayButton__playIcon'
};


export default function TogglePlayButton(props) {
  var playing = props.playing;

  var className = '' + bem(style.togglePlayButton, playing && 'playing') + (props.className ? ' ' + props.className : '');

  return h(
    'button',
    { className: className, onClick: props.onClick },
    h(
      'span',
      { className: 'nrk-sr' },
      playing ? 'Sett video på pause' : 'Spill av video'
    ),
    h('svg', {
      className: style.togglePlayButton__pauseIcon,
      'aria-hidden': 'true',
      dangerouslySetInnerHTML: {
        __html: '<use xlink:href="#nrk-media-pause" />'
      }
    }),
    h('svg', {
      className: style.togglePlayButton__playIcon,
      'aria-hidden': 'true',
      dangerouslySetInnerHTML: {
        __html: '<use xlink:href="#nrk-media-play" />'
      }
    })
  );
}


// WEBPACK FOOTER //
// ./node_modules/@nrk/dh-feature-components/dist/module/video/VideoPlayer/TogglePlayButton.js